<template>
  <div>
    <b-tabs
      content-class="py-3"
      v-model="selected_tab"
      pills
      fill
      justified
      nav-class="d-block d-md-flex option-tabs"
    >
      <b-tab title="DETALLE" active>
        <div>
          <showApartment
            :asset_id="asset_id"
            :key="asset_id"
            :features="features"
            :photos="photos"
            :images="images"
          />
        </div>
      </b-tab>
      <template v-if="showPayment">
        <b-tab
          title="PAGOS"
          v-if="
            customerId == 59 ||
            customerId == 129 ||
            customerId == 114 ||
            customerId == 147
          "
        >
          <div>
            <paymentsToku :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>

        <b-tab title="PAGOS" v-else-if="customerId == 121 || customerId == 146">
          <div>
            <paymentsBlank :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="PAGOS" v-else-if="customerId == 138">
          <div>
            <paymentsOtrosPagos :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="PAGOS" v-else-if="haveForpay">
          <div>
            <paymentsForpay :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="PAGOS" v-else-if="haveFintoc()">
          <div>
            <paymentsFintoc :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="PAGOS" v-else>
          <div>
            <payments :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
      </template>
      <b-tab title="DOCUMENTOS" v-if="showDocuments">
        <div>
          <documents :asset_id="asset_id" :key="asset_id" />
        </div>
      </b-tab>
      <b-tab title="PAGOS AUTOMÁTICOS" v-if="checkPac">
        <PaymentOptions
          :asset_id="asset_id"
          :project_id="project_id"
          :key="asset_id"
        />
      </b-tab>
      <b-tab title="PAGOS AUTOMÁTICOS" v-if="haveForpay">
        <PaymentForpayOptions
          :asset_id="asset_id"
          :project_id="project_id"
          :key="asset_id"
        />
      </b-tab>
      <b-tab title="POSTVENTA" v-if="checkAftersale && haveAftersale">
        <div>
          <aftersale
            :asset-id="asset_id"
            :key="asset_id"
            :contract-id="apartment.contract_id"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import showApartment from "./ShowApartment";
import payments from "./payments/Payments";
import aftersale from "./aftersale/Aftersale";
import paymentsToku from "./payments/PaymentsToku";
import paymentsFintoc from "./payments/PaymentsFintoc";
import paymentsForpay from "./payments/PaymentsForpay";
import PaymentsBlank from "./payments/PaymentsBlank";
import PaymentsOtrosPagos from "./payments/PaymentsOtrosPagos";
import documents from "./documents/Documents";
import PaymentOptions from "./paymentOptions";
import PaymentForpayOptions from "./paymentForpayOptions";

export default {
  name: "options",
  components: {
    showApartment,
    payments,
    aftersale,
    documents,
    paymentsToku,
    paymentsFintoc,
    paymentsForpay,
    PaymentOptions,
    PaymentsOtrosPagos,
    PaymentsBlank,
    PaymentForpayOptions,
  },
  props: {
    asset_id: { default: null },
    tab_index: { default: 0 },
    project_id: { default: null },
    photos: { default: [] },
    images: { default: [] },
    features: { default: [] },
  },
  mounted() {
    this.$store.commit("setCards");
  },
  data() {
    return {
      selected_tab: this.tab_index,
    };
  },
  methods: {
    haveFintoc() {
      let fintoc = [
        7, 13, 82, 1, 2, 53, 68, 42, 97, 96, 103, 102, 113, 101, 121, 138, 137,
        143,
      ];
      return fintoc.includes(this.customerId) ? true : false;
    },
  },
  watch: {
    asset_id: {
      handler: function () {
        this.selected_tab = 0;
      },
    },
  },
  computed: {
    domain() {
      return this.$store.getters.getCustomerDomain;
    },
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : 0;
    },
    showPayment() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_payment
        : false;
    },
    haveForpay() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.products.find(
            (product) => product.name == "Forpay"
          )
          ? true
          : false
        : false;
    },
    showDocuments() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_document
        : false;
    },
    project() {
      return this.apartment
        ? this.$store.getters.getProjectByMoby(this.apartment.project_id)
        : null;
    },
    address() {
      return this.project
        ? `${this.project.direccion.direccion}, ${this.project.direccion.comuna}`
        : "";
    },
    addressCountry() {
      return this.project
        ? `${this.project.direccion.ciudad} ${this.project.direccion.pais}`
        : "";
    },
    apartment() {
      return this.$store.getters.getApartmentById(parseInt(this.asset_id));
    },
    haveAftersale() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.products.find(
            (product) => product.name == "PostVenta"
          )
          ? true
          : false
        : false;
    },
    checkAftersale() {
      if (this.apartment && this.$store.state.haveAftersale) {
        if (this.$store.state.haveAftersale.length > 0) {
          if (
            this.$store.state.haveAftersale.find(
              (elem) => elem.id == this.apartment.project_id
            )
          ) {
            return this.$store.state.haveAftersale
              .find((elem) => elem.id == this.apartment.project_id)
              .value.includes(this.apartment.asset_state)
              ? this.$store.state.haveAftersale.find(
                  (elem) => elem.id == this.apartment.project_id
                )
              : false;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkPac() {
      if (this.$store.getters.getCustomerData) {
        let fintoc = this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Fintoc"
        )
          ? true
          : false;
        let oneclick = false;
        if (this.customerId == 25) {
          if (
            this.project_id == 3 ||
            this.project_id == 9 ||
            this.project_id == 10 ||
            this.project_id == 11
          ) {
            oneclick = this.$store.getters.getCustomerData.products.find(
              (product) => product.name == "Pago One Click"
            )
              ? true
              : false;
          } else {
            oneclick = false;
          }
        } else {
          oneclick = this.$store.getters.getCustomerData.products.find(
            (product) => product.name == "Pago One Click"
          )
            ? true
            : false;
        }
        return fintoc || oneclick ? true : false;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped></style>
